import React from 'react';

interface TaskColorProps {
    fill?: string;
}

export const TaskColor = ({ fill = '#818998' }: TaskColorProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4147_1310)">
                <g clipPath="url(#clip1_4147_1310)">
                    <path
                        d="M11.6666 7.33333C12.2189 7.33333 12.6666 6.88561 12.6666 6.33333C12.6666 5.78104 12.2189 5.33333 11.6666 5.33333C11.1143 5.33333 10.6666 5.78104 10.6666 6.33333C10.6666 6.88561 11.1143 7.33333 11.6666 7.33333Z"
                        fill={fill}
                    />
                    <path
                        d="M8.33331 5.33333C8.8856 5.33333 9.33331 4.88561 9.33331 4.33333C9.33331 3.78104 8.8856 3.33333 8.33331 3.33333C7.78103 3.33333 7.33331 3.78104 7.33331 4.33333C7.33331 4.88561 7.78103 5.33333 8.33331 5.33333Z"
                        fill={fill}
                    />
                    <path
                        d="M5 7.33333C5.55228 7.33333 6 6.88561 6 6.33333C6 5.78104 5.55228 5.33333 5 5.33333C4.44772 5.33333 4 5.78104 4 6.33333C4 6.88561 4.44772 7.33333 5 7.33333Z"
                        fill={fill}
                    />
                    <path
                        d="M5 11.3333C5.55228 11.3333 6 10.8856 6 10.3333C6 9.78104 5.55228 9.33333 5 9.33333C4.44772 9.33333 4 9.78104 4 10.3333C4 10.8856 4.44772 11.3333 5 11.3333Z"
                        fill={fill}
                    />
                    <path
                        d="M8.05531 16C6.46148 15.9999 4.90402 15.5236 3.58265 14.6324C2.26128 13.7412 1.23625 12.4756 0.63898 10.9979C0.0417147 9.52019 -0.10055 7.89778 0.23043 6.33869C0.56141 4.77961 1.35055 3.35492 2.49664 2.24733C3.26663 1.4973 4.18112 0.911714 5.1845 0.526175C6.18789 0.140637 7.2592 -0.0367968 8.33331 0.00466273C10.3631 0.0994043 12.2833 0.953318 13.7132 2.39715C15.1431 3.84098 15.9783 5.76934 16.0533 7.8C16.0809 8.83558 15.9054 9.86654 15.5366 10.8347C15.4616 11.0319 15.3382 11.207 15.1778 11.3441C15.0174 11.4812 14.8251 11.5759 14.6186 11.6193C14.4087 11.6657 14.1905 11.6582 13.9843 11.5974C13.7781 11.5367 13.5906 11.4247 13.4393 11.272L13.3726 11.2053C13.0388 10.8716 12.6132 10.6447 12.1501 10.5536C11.6869 10.4625 11.2071 10.5113 10.7717 10.6939C10.3364 10.8764 9.96523 11.1844 9.7055 11.5785C9.44578 11.9727 9.30926 12.4353 9.31331 12.9073L9.33998 15.918L8.72398 15.9693C8.50198 15.9853 8.28064 16 8.05531 16ZM8.05531 1.33333C6.2872 1.32537 4.58835 2.02012 3.33248 3.26474C2.07661 4.50935 1.3666 6.20189 1.35864 7.97C1.35069 9.73811 2.04543 11.437 3.29005 12.6928C4.53467 13.9487 6.2272 14.6587 7.99531 14.6667L7.97931 12.9167C7.97629 12.424 8.07081 11.9356 8.25743 11.4796C8.44405 11.0237 8.71907 10.6092 9.06664 10.26C9.76289 9.56466 10.7066 9.17411 11.6906 9.17411C12.6746 9.17411 13.6184 9.56466 14.3146 10.26L14.324 10.2693C14.6083 9.48929 14.7429 8.6626 14.7206 7.83266C14.6583 6.14102 13.9628 4.53452 12.7719 3.33151C11.581 2.12849 9.98157 1.41675 8.29064 1.33733C8.21153 1.33422 8.13286 1.33288 8.05464 1.33333H8.05531Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4147_1310">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_4147_1310">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
